/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../Fixes';
import Builder from '../../../../Builder';

const $root = ($protobuf.roots['default']|| ($protobuf.roots['default'] = new $protobuf.Root()));

const jsonData = {
  "squareup": {
    "nested": {
      "omg": {
        "nested": {
          "fiscalization": {
            "nested": {
              "qc": {
                "nested": {
                  "QcFiscalizationLineItemExtension": {
                    "fields": {
                      "notSubjectToMandatoryBilling": {
                        "type": "bool",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.omg?.nested?.fiscalization?.nested?.qc?.nested?.QcFiscalizationLineItemExtension) {
	$root.addJSON(jsonData);
}

/**
 * --
 * @desc Square-exclusive first-party proto extensions for line items participating in Québec
 * WEB-SRM fiscalization. Fields here apply only to sellers enrolled in Revenu Québec's
 * mandatory billing program (MEV-WEB / WEB-SRM).
 * --
 *
 * SOURCE QcFiscalizationLineItemExtension @ squareup/omg/fiscalization/qc/extensions.proto at 20:1
 */
export const QcFiscalizationLineItemExtension = $root.lookupType('squareup.omg.fiscalization.qc.QcFiscalizationLineItemExtension');
fixType(QcFiscalizationLineItemExtension);
Builder.createAndAttachToType(QcFiscalizationLineItemExtension);
